<template>
  <a-modal
    class="modal-content"
    :title="title"
    :width="600"
    :visible="visible"
    cancel-text="稍后联系"
    ok-text="已沟通"
    @ok="handleOk"
    @cancel="hideModal"
  >
    <EmptyData :dataSource="contactList" :loading="loading" :style-obj="{ height: '400px' }">
      <template slot="content">
        <div v-for="(item, index) in contactList" :key="index" style="padding: 10px">
          <span class="realname">{{ item.realname }}：</span>
          <span>{{ item.phone }}</span>
        </div>
      </template>
    </EmptyData>
  </a-modal>
</template>

<script>
import { getAction, postAction } from '@/api/manage'

export default {
  name: 'SchoolHomeComModal',
  props: {
    title: {
      type: String,
      default: '家校沟通',
    },
  },
  data() {
    return {
      visible: false,
      form: {},
      rules: {},
      currRecord: {},
      loading: false,
      contactList: [],
    }
  },
  methods: {
    showModal(data) {
      this.contactList = []
      this.loading = true
      getAction('/studentEment/studentEment/HomeSchoolDiscuss', { studentId: data.studentId })
        .then((res) => {
          console.log('联系方式：', res)
          if (res.success) {
            this.contactList = res.result
          }
        })
        .finally(() => {
          this.loading = false
        })
      this.visible = true
      this.currRecord = data
    },
    hideModal() {
      this.visible = false
    },
    async handleOk() {
      const params = {
        id: this.currRecord.id,
        comment: '已与家长进行沟通',
        visible: 1,
      }
      const res = await postAction('/aigoes/schoolWarnRecord/warnProcess', params)
      if (res.success) {
        this.$message.success(res.message || '操作成功')
        // this.$emit('refreshData')
      } else {
        this.$message.error(res.message || '操作失败')
      }
      this.hideModal()
    },
  },
}
</script>
<style scoped lang="less">
.modal-content {
  /deep/ .ant-modal-header {
    border-bottom: none;
  }
  /deep/ .ant-modal-body {
    overflow-y: auto;
    height: 400px;
    padding: 0 !important;
    margin: 0 24px 10px;
  }
  /deep/ .ant-upload {
    height: 149px;
  }
}
.modal-body {
  font-size: 16px;
  font-weight: bold;
  padding-bottom: 20px;
}
.realname {
  //margin-right: 5px;
}
</style>
